import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { FeatureFlag } from 'fourwaves-shared';
import { getFeatureUpgradeType } from '~/services/featureMapping';
import { UpgradeCheckoutEvents, UpgradeCheckoutState } from './types';

@Component
export default class UpgradeMixin extends Vue {
  @Prop({ type: String, default: null }) readonly feature!: FeatureFlag | null;
  @Prop(Boolean) readonly renew!: boolean;
  @Prop(Boolean) readonly addEvents!: boolean;

  returnFocusTarget: HTMLButtonElement | EventTarget | null = null;

  get isAddOnFeature() {
    return !!this.feature && getFeatureUpgradeType(this.feature).isAddOn;
  }

  get isPackageFeature() {
    return !!this.feature && getFeatureUpgradeType(this.feature).upgradePackage != null;
  }

  get actionLabel() {
    if (this.renew) return this.$t('plans.cta.renew');
    return this.isAddOnFeature ? this.$t('plans.cta.addon') : this.$t('plans.cta.package');
  }

  get state() {
    if (this.renew) return UpgradeCheckoutState.Renew;
    if (this.addEvents) return UpgradeCheckoutState.AddEvents;
    if (this.isAddOnFeature) return UpgradeCheckoutState.AddOns;
    return UpgradeCheckoutState.Default;
  }

  get isCheckoutInitiating() {
    return this.$wait.is(`initCheckout-${this.feature}`);
  }

  public onUpgrade() {
    this.$nuxt.$emit(UpgradeCheckoutEvents.Open, this.state, this.feature);
    this.$nuxt.$once(UpgradeCheckoutEvents.Close, () => {
      if (this.returnFocusTarget instanceof HTMLButtonElement) this.returnFocusTarget?.focus();
    });
  }
}
